import { Team } from '../app/types';

export const getTeamsOfDepartment = (departmentId?: number, teams: Team[] = []): Team[] => {
  if (!departmentId) {
    return teams;
  }

  return teams.filter((t) => t.department?.id === departmentId);
};
